// extracted by mini-css-extract-plugin
export default {"cardsContainer":"sub-products_cardsContainer__AIpE4"};